import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CookieService } from './cookie.service';

@Injectable({
  providedIn: 'root'
})
export class AgeVerificationService {
  private readonly COOKIE_NAME = 'age_verified';
  private readonly COOKIE_EXPIRES_DAYS = 365; // 1 year
  private platformId = inject(PLATFORM_ID);
  private cookieService = inject(CookieService);

  isAgeVerified(): boolean {
    if (!isPlatformBrowser(this.platformId)) return false;
    const cookie = this.cookieService.get(this.COOKIE_NAME);
    return cookie === '1' ;
  }

  setAgeVerified(verified: boolean): void {
    if (!isPlatformBrowser(this.platformId)) return;
    const value = verified ? '1' : '0';
    const expiresDate = this.cookieService.getExpiresDate(this.COOKIE_EXPIRES_DAYS);
    this.cookieService.set(this.COOKIE_NAME, value, expiresDate, '/');
  }
}
